import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { CourtCase } from '../shared/court-case';
import { environment } from './../../environments/environment';
import { WrappedResponse } from '../shared/wrapped-response';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { FileNumberUtil } from '../shared/file-number-util';

@Injectable()
export class PrintService {

  // TODO: Investigate - This is in a top-level folder, but appears to be tailored for only civil.
  constructor(private http: HttpClient) { }

  requestPdf(cases: CourtCase[]): Observable<string> {
        const url = environment.proxyBaseUrl + 'civil_cases/case_reports/report';
        const data = this.buildReportRequestData(cases, 'V');

        return this.http.post<WrappedResponse>(url, data)
                    .map(response => response.links[0].href)
                    .catch(this.handleError);
  }

  // TODO: why does the "PrintService" do emails?
   requestEmail(cases: CourtCase[], emailAddress: string): Observable<WrappedResponse> {
        const url = environment.proxyBaseUrl + 'civil_cases/case_reports/email';
        const data = this.buildReportRequestData(cases, 'V', emailAddress);

        return this.http.post<WrappedResponse>(url, data)
                    .catch(this.handleError);

  }

   buildReportRequestData(cases: CourtCase[], reportType: ReportType, emailAddress?: string) {
        const caseListForResult: ReportCase[] = [];

        for (let acase of cases) {
            const caseIdentifier = acase.getCaseIdentifier();
            const fileNumberString = FileNumberUtil.normalizeCaseNumber(caseIdentifier.caseNumber);
            caseListForResult.push({
                fileNumber: fileNumberString,
                reportTypeCode: reportType,
                countyName: caseIdentifier.county
            });
        }
        const result: ReportRequest = { courtCases: caseListForResult };
        if (emailAddress) {
          result.emailAddresses = [emailAddress];
        }
        return result;
  }

  // TODO: revisit this
  private handleError(error: HttpErrorResponse) {
    // TODO: if this error handling is consistent across all http calls,
    // we can push this code to CiprsHttp and avoid repeating the logic
    let errorMessage: string;
    if (error.status === 0) {
      // TODO: what should the user be directed to do?
      errorMessage = 'An error occurred. The server could not be reached.';
    } else {
      let wrappedErrorResponse = error.error || {};
      if (wrappedErrorResponse.responseCode === 404) {
        errorMessage = 'No matching records were found.';
      } else {
        if (wrappedErrorResponse.messages && wrappedErrorResponse.messages[0]) {
          errorMessage = wrappedErrorResponse.messages[0].message;
        } else {
          errorMessage = 'An error occurred. The document cannot be generated'; // TODO: what should the user be directed to do?
        }
        console.log('error message is ' + errorMessage + ' ' + ' response code is ' +  wrappedErrorResponse.responseCode);
      }
    }
    return new ErrorObservable(errorMessage);
  }
}

interface ReportRequest {
  courtCases: ReportCase[];
  emailAddresses?: string[];
}

interface ReportCase {
  fileNumber: string,
  reportTypeCode: ReportType,
  countyName: string
}

type ReportType = 'V'; // At this point, we only seem to support 'V'



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/print/print.service.ts